/* global console */

import React, { useEffect } from "react";
import { DocumentListPage } from "../../pages/document/DocumentListPage";
import Home from "../Home";
import { NewObjectPage } from "../../pages/coobjects/NewObjectPage";
import { EditObjectPage } from "../../pages/coobjects/EditObjectPage";
import NotFoundPage from "../../pages/infos/NotFoundPage";
import { NewDocumentPage } from "../../pages/document/NewDocumentPage";
import { DocumentPropertiesPage } from "../../pages/document/DocumentPropertiesPage";
import { SettingsPage } from "../../pages/settings/SettingsPage";
import {
  CHOOSECONFIG,
  DETAILS_DOCUMENT,
  DOCUMENT_PROPERTIES,
  DOCUMENTS_LISTS,
  EDIT_OBJECT,
  HOME,
  IMPORT,
  INFO,
  IXBRL,
  MOVE,
  NEW_DOCUMENT,
  NEW_OBJECT,
  COPY_CUT_PASTE_PANEL_MESSAGE,
  OBJECTS_LIST,
  REFRESH_MULTI,
  SETTINGS,
  SOURCES,
  SYNCH_RESTORE,
  TEMPLATE,
  UPDATES,
  DOWNLOAD_COPY,
    MAINTENANCEMODE,
} from "../../utils/constants/navigation";
import { useAppSelector } from "../../redux/hooks/hooks";
import { historyNavigation } from "../../redux/feature/general/navigation-slice";
import { SynchRestorePage } from "../../pages/document/SynchRestorePage";
import { ChooseConfigPage } from "../../pages/login/ChooseConfigPage";
import {
  configurationsNotEmpty,
  selectActiveConfiguration,
  selectIsConfigured,
} from "../../redux/feature/settings/configurations-slice";
import { ImportDocumentPage } from "../../pages/document/ImportDocumentPage";
import { ObjectsListPage } from "../../pages/document/ObjectsListPage";
import { UpdatesPage } from "../../pages/document/UpdatesPage";
import { DocumentSourcesPage } from "../../pages/document/DocumentSourcesPage";
import { TagetikInfo } from "../../pages/infos/TagetikInfo";
import { getExternalConfigs } from "../../api/config/ExternalConfig";
import { store } from "../../redux/store/store";
import { setExternalConfigs } from "../../redux/feature/settings/external-configs-slice";
import { MoveObjectPage } from "../../pages/coobjects/MoveObjectPage";
import { SeahorsePage } from "../../pages/seahorse/SeahorsePage";
import { CopyCutPasteMessagePanel } from "../layout/CopyCutPasteMessagePanel";
import { validateString } from "../../utils/helpers/ObjectCheckerHelper";
import { DownloadCopyPage } from "../../pages/document/DownloadCopyPage/DownloadCopyPage";
import { MaintenanceMode } from "../generic/MaintenanceMode";
import { WelcomePage } from "../../pages/settings/WelcomePage";

export const NavigationHandler: React.FunctionComponent = () => {
  const pageHistoryNavigation = useAppSelector(historyNavigation);
  const isConfigured = useAppSelector(selectIsConfigured);
  const presenceOfConfigurations = useAppSelector(configurationsNotEmpty);
  const activeConfiguration = useAppSelector(selectActiveConfiguration);

  const [page, setPage] = React.useState<{
    pageName: string;
    pageElement: React.ReactElement;
  }>({ pageName: DOCUMENT_PROPERTIES, pageElement: null });

  useEffect(() => {
    if (pageHistoryNavigation && pageHistoryNavigation.length > 0) {
      const page = pageHistoryNavigation[pageHistoryNavigation.length - 1];
      setPage({ pageName: page, pageElement: null });
    }
  }, [pageHistoryNavigation]);

  useEffect(() => {
    if (isConfigured && activeConfiguration?.authData) {
      if (
        validateString(activeConfiguration.authData.access_token) &&
        Date.now() < activeConfiguration.authData.expires_at * 1000
      ) {
        getExternalConfigs().then((value) => store.dispatch(setExternalConfigs(value)));
      }
    } else if (activeConfiguration && !activeConfiguration.authData) {
      setPage((oldPage) => ({ pageName: oldPage.pageName, pageElement: getRender(oldPage.pageName) }));
    }
  }, [isConfigured, activeConfiguration]);

  useEffect(() => {
    if (!page.pageElement)
      setPage((oldPage) => ({ pageName: oldPage.pageName, pageElement: getRender(oldPage.pageName) }));
  }, [page.pageElement]);

  const getRender = (pageName: string) => {
    if (pageName == CHOOSECONFIG && presenceOfConfigurations) return <ChooseConfigPage />;
    if (pageName == SETTINGS) return <SettingsPage />;

    if (!presenceOfConfigurations) return <WelcomePage />;

    if (!isConfigured || !activeConfiguration.authData) return <ChooseConfigPage />;

    switch (pageName) {
      case COPY_CUT_PASTE_PANEL_MESSAGE:
        return <CopyCutPasteMessagePanel />;
      case HOME:
        return <Home />;

      case NEW_OBJECT:
        return <NewObjectPage />;

      case EDIT_OBJECT:
        return <EditObjectPage />;

      case IXBRL:
        return <SeahorsePage />;

      case MOVE:
        return <MoveObjectPage />;

      case REFRESH_MULTI:
        return <NotFoundPage />;

      case NEW_DOCUMENT:
        return <NewDocumentPage />;

      case DETAILS_DOCUMENT:
        return <NotFoundPage />;

      case TEMPLATE:
        return <NotFoundPage />;

      case DOCUMENT_PROPERTIES:
        return <DocumentPropertiesPage />;

      case SETTINGS:
        return <SettingsPage />;

      case CHOOSECONFIG:
        return <ChooseConfigPage />;

      case DOCUMENTS_LISTS:
        return <DocumentListPage />;

      case SYNCH_RESTORE:
        return <SynchRestorePage />;

      case IMPORT:
        return <ImportDocumentPage />;

      case OBJECTS_LIST:
        return <ObjectsListPage />;

      case UPDATES:
        return <UpdatesPage />;

      case SOURCES:
        return <DocumentSourcesPage />;

      case INFO:
        return <TagetikInfo />;

      case DOWNLOAD_COPY:
        return <DownloadCopyPage />;

      case MAINTENANCEMODE:
        return <MaintenanceMode />;

      default:
        console.error("Navigation error!", { pageName });
        return <>NAVIGATION ERROR</>;
    }
  };
  return page.pageElement;
};

export default NavigationHandler;
